export default "__VITE_ASSET__ld48fbzl__"